export default "__VITE_ASSET__BbvHqQNE__"